import { FormikErrors } from 'formik';
import { ChangeEvent, useEffect, useState } from 'react';
import { useAuth } from 'hooks';
import { FormOption, Reason, ReturnEntry } from 'types';
import { Checkbox, Product, Select, Text } from 'components';
import { parseToReturnEntry } from 'helpers';
import { FontSize, RETURN_REASONS } from 'commons';
import * as S from './styles';

type EntryProps = {
  isEnable: boolean;
  entry: number;
  reason: string;
  additionalReason: string;
  additionalInformation: string;
};

interface Props {
  returnEntry: ReturnEntry;
  name: string;
  errors: FormikErrors<EntryProps> | any;
  values: EntryProps;
  setFieldValue: (field: string, value: any) => any;
  handleChange: (
    e: string | ChangeEvent<any> | HTMLInputElement | Event
  ) => void;
}

function reasonsToOptions(reasons: Reason[]): FormOption[] {
  return reasons
    .filter(({ code }) => RETURN_REASONS[code])
    .map(({ code }) => {
      return {
        label: RETURN_REASONS[code],
        value: code,
      };
    });
}

export function ProductForm({
  returnEntry,
  errors,
  name,
  values,
  handleChange,
  setFieldValue,
}: Props) {
  const { user } = useAuth();
  const { isAdmin } = user;

  const { isEnable } = values;
  const { entry, reasons } = returnEntry;
  const customEntry = parseToReturnEntry(entry);

  const reasonsOptions: FormOption[] = reasonsToOptions(reasons);

  const selectedReason = reasons.find(
    (reason) => reason.code === values.reason
  ) ?? { additionalReasons: [] };

  const [subReasonsOptions, setSubReasonsOptions] = useState(
    reasonsToOptions(selectedReason.additionalReasons)
  );

  useEffect(() => {
    setSubReasonsOptions(reasonsToOptions(selectedReason.additionalReasons));
    setFieldValue(`${name}.additionalReason`, '');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.reason]);

  return (
    <S.Main $isEnable={isEnable}>
      <S.CheckboxLabel>
        <Checkbox
          checked={isEnable}
          name={`${name}.isEnable`}
          onChange={handleChange}
          disabled={isAdmin}
        />

        <Text>Devolver este item?</Text>
      </S.CheckboxLabel>

      <S.Wrapper>
        <Product entry={customEntry} clearBorder />

        <S.ProductForm>
          <S.LabelWrapper>
            <Text size={FontSize.font12}>Informe a razão da devolução</Text>

            <Select.Wrapper
              status={errors?.reason ? 'error' : 'default'}
              disabled={!isEnable || isAdmin}
              name={`${name}.reason`}
              onChange={handleChange}
              options={reasonsOptions}
            >
              <Select.Input placeholder="Selecione a razão da devolução" />

              <Select.StatusArrow />
            </Select.Wrapper>
          </S.LabelWrapper>

          <S.LabelWrapper key={subReasonsOptions[0]?.value || ''}>
            <Text size={FontSize.font12}>Mais detalhes</Text>

            <Select.Wrapper
              disabled={!isEnable || subReasonsOptions.length === 0 || isAdmin}
              name={`${name}.additionalReason`}
              onChange={handleChange}
              options={subReasonsOptions}
            >
              <Select.Input placeholder="Mais detalhes" />

              <Select.StatusArrow />
            </Select.Wrapper>
          </S.LabelWrapper>

          <S.LabelWrapper>
            <Text size={FontSize.font12}>Informe a razão da devolução</Text>

            <S.Textarea
              placeholder="Insira aqui mais detalhes"
              disabled={!isEnable || isAdmin}
              name={`${name}.additionalInformation`}
              onChange={handleChange}
              maxLength={255}
            />
          </S.LabelWrapper>
        </S.ProductForm>
      </S.Wrapper>
    </S.Main>
  );
}
